import classes from './Error404.module.css';
import emojy from '../../assets/images/sadEmojy.png';
function Error404() {
    return <div className={classes.card}>
        <p>با عرض پوزش  صفحه مورد نظر وجود ندارد</p> 
        <h1>ERROR 404</h1>
        
        <img className={classes.emojy} alt='emojy'src={emojy}></img>
        </div>
}
export default Error404;